import * as React from "react";
import { SVGProps } from "react";
export const ChevronLineRightIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.85521 17.458L11.7932 10.521C11.8899 10.4237 11.9592 10.323 12.0012 10.219C12.0432 10.115 12.0642 10.0073 12.0642 9.896C12.0642 9.78467 12.0432 9.677 12.0012 9.573C11.9592 9.469 11.8899 9.36833 11.7932 9.271L4.83421 2.313C4.62621 2.10433 4.37288 2 4.07421 2C3.77554 2 3.52221 2.11133 3.31421 2.334C3.09154 2.542 2.98721 2.79867 3.00121 3.104C3.01521 3.41 3.12621 3.667 3.33421 3.875L9.35521 9.896L3.31421 15.938C3.11954 16.132 3.02221 16.3853 3.02221 16.698C3.02221 17.0107 3.11954 17.264 3.31421 17.458C3.52221 17.6667 3.77888 17.771 4.08421 17.771C4.39021 17.771 4.64721 17.6667 4.85521 17.458Z"
            fill="currentColor"
        />
        <path
            d="M15.0642 16.7999C15.0642 17.1236 15.1633 17.4048 15.3614 17.6434C15.5602 17.8811 15.7945 18 16.0642 18C16.3339 18 16.5678 17.8811 16.7659 17.6434C16.9648 17.4048 17.0642 17.1236 17.0642 16.7999V3.20007C17.0642 2.87639 16.9648 2.59523 16.7659 2.35659C16.5678 2.11886 16.3339 2 16.0642 2C15.7945 2 15.5602 2.11886 15.3614 2.35659C15.1633 2.59523 15.0642 2.87639 15.0642 3.20007V16.7999Z"
            fill="currentColor"
        />
    </svg>
);
ChevronLineRightIcon.displayName = "ChevronLineRightIcon";
